class ApiEndpoints {
  static serverURL =
    // process.env.REACT_APP_SERVER_URL ||
    "https://server.ttrprogramming.com";
    // "https://dev.server.ttrprogramming.com";
    // "http://192.168.1.25:4000";
  static assetURL =
    // process.env.REACT_APP_ASSET_URL ||
    "https://assets.ttrprogramming.com";
  static baseApiURL = `${this.serverURL}/api/v1`;
  static baseAssetUrl = `${this.assetURL}`;

  //for admin
  static coach = `/coach`;
  static getCoach = `/coach`;
  static createCoachAccount = `${this.coach}`;
  static deleteCoach = `${this.coach}`;
  static coachLogin = `${this.coach}/login`;
  static coachProfile = `${this.coach}/profile`;
  static changeCoachProfile = `${this.coach}/profile`;
  static forgetCoachPassword = `${this.coach}/forget-password`;
  static resetCoachPassword = `${this.coach}/reset-password`;
  static changeCoachPassword = `${this.coach}/change-password`;
  static changeCoachEmail = `${this.coach}/change-email`;

  //for gym
  static gym = `/gym`;
  static getGyms = `${this.gym}`;

  //for client
  static client = `/client`;
  static getClients = `${this.client}`;
  static createClientAccount = `${this.client}`;
  static deleteClient = `${this.client}`;
  static getClientsWithFitnessStatus = `${this.client}/fitness-status`;
  static createClient = `${this.client}`;

  //for exercise
  static exercise = `/workout`;
  static getExercises = `${this.exercise}`;
  static deleteExercise = `${this.exercise}`;

  //for client
  static clientReport = `/fitness-report`;
  static getClientReports = `${this.clientReport}`;
  static createClientReport = `${this.clientReport}`;
  static updateClientReportByReportId = `${this.clientReport}`;
  static getclientBlockById = `${this.clientReport}`;
  static clientReportSummaryDownload = `${this.clientReport}/download/client`;
  static clientReportSummarySent = `${this.clientReport}/sent/client`;
  static createClientReportBiometric = `${this.clientReport}/body`;
  static createClientReportExersice = `${this.clientReport}/workout`;
  static getClientReportsByClientId = `${this.clientReport}/client`;
  static sendAllClientsReport = `${this.clientReport}/client/share`;
  static updateClientReportBiometricByReportId = `${this.clientReport}/body`;
  static updateClientReportExersiceByReportId = `${this.clientReport}/workout`;

  //report
  static clientSummary = "/performance-summary/year";
  static clientPerformanceSummary = "/performance-summary/dashboard/year";

  //for reset year
  static resetYear = "/system-settings";
  static getYearOptions = "/system-settings";
}
export default ApiEndpoints;
